import React from 'react';
import { Link } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';
import { toggleAccountMenuDropdown } from '../reducers/customer/actions';
import styled from 'styled-components';
import { ADMIN_AUTH_ROLES } from 'utils/appConstants';
import profileIcon from 'assets/user-icon.svg';

const enableCustomLogo =
  window.env.REACT_APP_ENABLE_CUSTOM_LOGO_UPLOAD === 'true';

const ProfileIcon = styled.img`
  height: 20px;
  width: 20px;
  display: inline;
  vertical-align: middle;
  cursor: pointer;
  &:hover {
    background-color: ${({ showDropdown }) =>
      showDropdown ? 'rgba(7, 121, 175, 0.2)' : 'rgba(7, 121, 175, 0.05)'};
  }
`;

const DropdownOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
  min-width: 158px;
  position: absolute;
  top: 51px;
  z-index: ${({ highestPriority }) => (highestPriority ? 100 : 3)};
`;

const NavLinkOption = styled(Link)`
  background-color: ${({ showDropdown }) =>
    showDropdown ? 'rgba(7, 121, 175, 0.2)' : 'transparent'};
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 15px;
  outline: none;
  padding: 1em 0.5em;
  text-align: left;
  &:visited {
    color: #0d151f;
  }
  &:hover {
    background-color: ${({ showDropdown }) =>
      showDropdown ? 'rgba(7, 121, 175, 0.2)' : 'rgba(7, 121, 175, 0.05)'};
  }
  &:first-of-type {
    padding-top: 0.75em;
  }
  &:last-of-type {
    padding-bottom: 0.75em;
  }
`;

const Button = styled.div`
  background-color: ${({ showDropdown }) =>
    showDropdown ? 'rgba(7, 121, 175, 0.2)' : 'transparent'};
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 15px;
  outline: none;
  padding: 1em 0.5em;
  text-align: left;
  &:visited {
    color: #0d151f;
  }
  &:hover {
    background-color: ${({ showDropdown }) =>
      showDropdown ? 'rgba(7, 121, 175, 0.2)' : 'rgba(7, 121, 175, 0.05)'};
  }
  &:first-of-type {
    padding-top: 0.75em;
  }
  &:last-of-type {
    padding-bottom: 0.75em;
  }
`;

const AccountMenuDropdown = ({ logout }) => {
  const authenticatedUser = useSelector(state => state.auth.authenticatedUser);
  const showAcctMenuDropdown = useSelector(
    state => state.customer.showAcctMenuDropdown
  );
  const dispatch = useDispatch();
  const { roleName } = authenticatedUser;

  const AcctDropdownList = () => (
    <DropdownOptionContainer highestPriority={true}>
      <NavLinkOption
        to="/account"
        onClick={() => dispatch(toggleAccountMenuDropdown(false))}
      >
        Account Info
      </NavLinkOption>
      {enableCustomLogo && ADMIN_AUTH_ROLES.includes(roleName) && (
        <NavLinkOption
          to="/change-logo"
          onClick={() => dispatch(toggleAccountMenuDropdown(false))}
        >
          Change Logo
        </NavLinkOption>
      )}
      <Button onClick={logout}>Sign Out</Button>
    </DropdownOptionContainer>
  );

  return (
    <>
      <ProfileIcon
        onClick={() =>
          dispatch(toggleAccountMenuDropdown(!showAcctMenuDropdown))
        }
        src={profileIcon}
        alt="header-profile-icon"
      />
      {showAcctMenuDropdown && <AcctDropdownList />}
    </>
  );
};

export default AccountMenuDropdown;
